module.exports = __webpack_public_path__ + "static/media/mobile-sdk.5b283c4e.svg";